
























import {Vue, Component, Model, Prop, Watch} from 'vue-property-decorator';
import IntervalDateTimeSelect from '@c/IntervalDateTimeSelect.vue';
import {DateTimeInterval} from '@u/dateTimeItervalUtils';
import SimpleDialog from '@c/SimpleDialog.vue';

@Component({
  components: {IntervalDateTimeSelect, SimpleDialog},
})
export default class Chips extends Vue {
  selectedItemIndex = 0;

  prevSelectedIndex = 0;

  isShowDialog = false;

  currentDateTimeInterval!: DateTimeInterval;

  setDateTimeInterval(currentDateTimeInterval: DateTimeInterval) {
    this.currentDateTimeInterval = currentDateTimeInterval;
  }

  @Watch('selectedItemIndex')
  onSelectedIndexChanged(value: any, oldValue: any) {
    this.prevSelectedIndex = oldValue;
  }

  @Prop() items!: any;
  @Model('change') item!: any;

  itemCustomInterval!: any;

  @Watch('item', {immediate: true})
  onChangeItem(item: any) {
    const index = this.items.findIndex((obj: any) => {
      return obj.name === item.name;
    });
    if (index !== -1) this.selectedItemIndex = index;
  }

  onClickChip(item: any) {
    if (item.duration) this.$emit('change', item);
    else {
      this.isShowDialog = true;
      this.itemCustomInterval = item;
    }
  }

  setupInterval() {
    this.itemCustomInterval = {
      ...this.itemCustomInterval,
      intervalCustom: {
        startDateTime: this.currentDateTimeInterval.startDateTime || 0,
        endDateTime: this.currentDateTimeInterval.endDateTime || 0,
      },
    };
    this.$emit('change', this.itemCustomInterval);
  }

  onCancel() {
    this.selectedItemIndex = this.prevSelectedIndex;
  }
}
